import React from "react";
import Icon from "@icon-park/react/es/all";
import styled, { keyframes } from "styled-components";
import { theme } from "@ifgengineering/component-library";
import { SearchContainer, SearchInput, SearchIconWrapper } from "./styled";

interface EisFundSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Show loading spinner (when fetching search results) */
  isLoading?: boolean;
}

const EisFundSearch: React.FC<EisFundSearchProps> = ({
  value,
  onChange,
  placeholder = "Search",
  isLoading = false,
}) => {
  return (
    <SearchContainer>
      <SearchInput
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid="eis-fund-search"
      />
      <SearchIconWrapper>
        {isLoading ? (
          <Spinner data-testid="eis-search-spinner" />
        ) : (
          <Icon type="Search" fill={theme.colors.SLATE500} size={20} />
        )}
      </SearchIconWrapper>
    </SearchContainer>
  );
};

export default EisFundSearch;

// Spinner animation
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${theme.colors.SLATE200};
  border-top-color: ${theme.colors.BLUE600};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;
